// Libraries
import { Button, ButtonProps } from '@chakra-ui/react';

/**
 * Component for a form submit button.
 * @param {ButtonProps} props - The props for the chakra button.
 * @returns {ReactElement} - The components form submit button.
 */
export const FormSubmit = (props: ButtonProps) => {
  const { children, fontSize = 'm', fontWeight = 'medium', variant = 'submit', type = 'submit', ...rest } = props;
  return (
    <Button
      _disabled={{
        opacity: 0.4,
        cursor: 'not-allowed',
        boxShadow: 'none',
        bg: 'submitScheme.500',
        _hover: {
          bg: 'submitScheme.500',
        },
      }}
      {...{ fontSize, fontWeight, variant, type }}
      {...rest}
    >
      {children}
    </Button>
  );
};
